/**
 * B_Sound.js
 *
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.26
 * @작성 : SuperMoon
 * @참조 :
 */
import BaseCanvas from 'canvas/base/dev/scripts/BaseCanvas';
import B_Util     from 'canvas/base/dev/util/B_Util';
import B_Define   from 'canvas/base/dev/util/B_Define'

/**
 * B_Sound - Public 명세
 *
 * - resEffect {arr} - 사용할 수 있는 Effect 명세 (수정불가)
 * - play(id) {func} - Effect 소리 출력하기
 * - toggle() {func} - Mute 토글
 *
 * */



const B_Sound = (function(){
	let objSingleton;
	let _this = undefined;

	// [V]
	const $ = {
		'_isMute'       : null,  // {bool} mute 여부
		'_bgm'          : null,  // {str} bgm
		'resEffect'     : null,  // {json} effect 모음
		'_srcEffect'    : null,  // {str} effect 경로
	};

	class B_Sound {
		constructor(mute, res, src, bgm) {
			if(objSingleton) return objSingleton;
			_this = this;

			// [S] mute, bgm, res, src 설정
		    this._isMute = (typeof mute == 'boolean' ? mute : false);
			this._bgm    = (typeof bgm == 'string' ? bgm : undefined);
		    if(typeof res != 'undefined') this._resEffect = res;
			if(typeof src != 'undefined') this._srcEffect = src;

			// [T] PreloadJS 이용하기
			// ===========================================

			let queue = new createjs.LoadQueue(true, this._srcEffect);
			queue.installPlugin(createjs.Sound);
			queue.addEventListener("complete", this._handleLoadComplete);
			queue.addEventListener("error",    this._handleError);
			// queue.addEventListener("progress", handleProgress);

			// SRC 확장자가 지원되지 않는 경우 다른 확장을 추가하여로드를 시도하십시오.
			createjs.Sound.alternateExtensions = ["mp3"];

			// [#CASE1] 효과음 추가
			const ARR_SOUND_LIST = Object.entries(this._resEffect).map((v) => {
				return { id : v[0], src : v[1] };
			});

			// [#CASE2] 배경음 추가
			if(typeof this._bgm != 'undefined') {
				ARR_SOUND_LIST.push({id: B_Define.BGM_ID, src : this._bgm});
			}
			queue.loadManifest(ARR_SOUND_LIST);
			// ===========================================


			// [T] SoundJS 이용하기 (기획적한계 - 간단 사운드를 처리하기위해 개발됨)
			// ===========================================
			// createjs.Sound.on("fileload", this._handleLoadComplete);
			// createjs.Sound.alternateExtensions = ["mp3"];
			//
			// // [S] bgm
			// if(this._bgm) createjs.Sound.registerSound({id: B_Define.BGM_ID, src : bgm});
			//
			// // [S] effect
			// createjs.Sound.registerSounds(
			// 	Object.entries($.resEffect).map((v) => {
			// 		return { id : v[0], src : v[1] };
			// 	}),
			// 	this._srcEffect);
			// ===========================================

			objSingleton = B_Util.getProtected(this);
			return objSingleton;
		}

		// [V]

		// @DES :: resEffect {json}
		get resEffect() { return Object.keys(this._resEffect); }

		// @DES :: isMute {boolean}
		get isMute() { return this._isMute };

		// [F] private

		/**
		 * [Function :: _handleLoadComplete]
		 *
		 * @DES ::
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		_handleLoadComplete(e) {
			if(
				!_this._isMute // mute = false 이고
				&&
				_this._bgm // bgm이 있다면
			) {
				_this._playLoop(B_Define.BGM_ID);
			}
		}

		/**
		 * [Function :: _handleError]
		 *
		 * @DES ::
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		_handleError(e) {
			B_Util.print('[코드모스] => 다음 사운드 파일의 경로를 확인하세요. ' + e.data.src);
		}

		/**
		 * [Function :: _playLoop]
		 *
		 * @DES ::
		 * @IP1 :: id {string}
		 * @O.P ::
		 * @S.E ::
		 */
		_playLoop(id) {
            createjs.Sound.play(
				id, {
					interrupt : createjs.Sound.INTERRUPT_NONE,
					loop      : -1,
					volume    : window.LC_VOLUME || 1
				}
			);
		}

		/**
		 * [Function :: _stop]
		 *
		 * @DES ::
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		_stop() {
			createjs.Sound.stop();
		}

		// [F] public

		/**
		 * [Function :: play]
		 *
		 * @DES :: 음악 플레이 by ID
		 * @IP1 :: id {str}
		 * @O.P :: null
		 * @S.E ::
		 */
		play(id) {
			if(this.resEffect.indexOf(id) != -1) {
				if(!this._isMute)
					createjs.Sound.play(
						id, {
							volume : B_Define.VOLUME_EFFECT
						}
					);
			}
			else B_Util.print('[코드모스] => 요청하신 Sound id는 리소스에 없는 id입니다.')
		}

		/**
		 * [Function :: toggle]
		 *
		 * @DES :: Mute Toogle 하기
		 * @IP1 :: status {boolean}
		 * @O.P :: null
		 * @S.E :: 특이사항없음
		 */
		toggle(status) {
			// console.log('status : ', status);
			// [#] 요청값이 있다면 그걸로 바꾸고 없다면 토글함
			if(status === 'boolean')
				this._isMute = status;
			else
				this._isMute = !this._isMute;

			// [#] sound 설정
			if(this._isMute === true) {
				// [CASE1] mute
				this._stop();
			}
			if(this._isMute === false) {
				// [CASE2] play
				if(this._bgm) this._playLoop(B_Define.BGM_ID);
			}
		}

		_compareInventoryNew (hero) {
			return this.answerSheet.inventory.expectation.value === hero.getEntryInventoryCount();
		}


	}

	B_Util.manageGetAndSet(B_Sound, $);
	return B_Sound;
}());

export default B_Sound;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/sound/B_Sound.js